// extracted by mini-css-extract-plugin
module.exports = {"input":"Invitations_input__3ftdg","download":"Invitations_download__3xGr6"};